import { useMemo, type ReactNode } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import 'dayjs/locale/zh-cn'
import '@fontsource/inter/latin.css'
import '@fontsource/jetbrains-mono/latin.css'
import App from './App'
import { themes, useThemeStore, initTheme } from '@/stores/theme'
import './index.css'

// 初始化主题
initTheme()

/** 动态主题包装器 */
function ThemeWrapper({ children }: { children: ReactNode }) {
  const current = useThemeStore((s) => s.current)
  const t = themes.find((item) => item.key === current) || themes[0]
  const c = t.colors

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: c.primary,
          colorInfo: c.primary,
          borderRadius: 8,
          fontSize: 14,
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif",
          colorBgContainer: '#ffffff',
          colorBorder: '#e8e4dc',
        },
        components: {
          Layout: {
            headerBg: '#ffffff',
            headerHeight: 60,
            headerPadding: '0 24px',
            bodyBg: '#f7f5f0',
          },
          Menu: {
            itemHeight: 44,
            itemBg: 'transparent',
            subMenuItemBg: 'transparent',
          },
          Card: {
            headerBg: 'transparent',
          },
          Button: {
            colorPrimary: c.primary,
            colorPrimaryHover: c.primaryLight,
            colorPrimaryActive: c.primaryDark,
            borderRadius: 8,
          },
          Input: {
            borderRadius: 8,
          },
          Table: {
            headerBg: '#f4f1ea',
            headerSplitColor: '#e8e4dc',
          },
          Tabs: {
            itemColor: '#7d8597',
            itemSelectedColor: c.primary,
            itemHoverColor: c.primary,
            inkBarColor: c.primary,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}

// 注意：不使用 <StrictMode> —— React 18 开发模式下 StrictMode 会双执行组件挂载
// 时的 useEffect，导致所有页面进入时接口请求触发两次（生产构建不受影响，但开发
// 环境表现为重复请求）。业务页面数据加载多为一次性请求，移除以保证开发/生产行为一致。
ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <ThemeWrapper>
      <App />
    </ThemeWrapper>
  </BrowserRouter>,
)
